import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "DumaExpertBéton - Expert en Béton Imprimé et Décoratif | Orange, Vaucluse",
  description = "Spécialiste du béton imprimé, désactivé, lissé, bâlé et ciré dans le Vaucluse. Rayon d'intervention de 65km autour de Sainte-Cécile-les-Vignes. Devis gratuit sous 24h. Plus de 10 ans d'expérience.",
  keywords = "béton imprimé, béton désactivé, béton lissé, béton ciré, béton décoratif, Orange, Vaucluse, PACA, terrasse béton, allée béton, plage piscine",
  image = "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200",
  url = "https://dumaexpertbeton.fr",
  type = "website"
}) => {

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="DumaExpertBéton" />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content="DumaExpertBéton" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Geo Tags */}
      <meta name="geo.region" content="FR-84" />
      <meta name="geo.placename" content="Orange" />
      <meta name="geo.position" content="44.1364;4.8089" />
      <meta name="ICBM" content="44.1364, 4.8089" />
    </Helmet>
  );
};

export default SEO;
